import { all } from 'redux-saga/effects';
import admin from './admin';
import authentication from './authentication';
import transcriptGetByLinksUUID from './transcriptGetByLinksUUID';
import conference from './conference';
import conferences from './conferences';
import transcript from './transcript';
import transcripts from './transcripts';
import organizations from './organizations';
import snackbar from './snackbar';
import sidebar from './sidebar';
import introMessages from './introMessages';
import blockedAttendees from './blockedAttendees';
import errorLogger from './errorLogger';
import attendees from './attendees';
import trsc from './trscService';

export default function* rootSaga() {
  yield all([
    admin(),
    authentication(),
    transcriptGetByLinksUUID(),
    conference(),
    conferences(),
    transcript(),
    transcripts(),
    organizations(),
    snackbar(),
    introMessages(),
    blockedAttendees(),
    errorLogger(),
    sidebar(),
    attendees(),
    trsc(),
  ]);
}



// WEBPACK FOOTER //
// ./redux/sagas/index.js